'use strict';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/observable/from';
import 'rxjs/Observable';
import {getOrganization, getOrgProfile} from '../../app/model/reducers/state';
import {IONIC_VIEW_ENTER, IONIC_VIEW_LEAVE, SCOPE_DESTROY} from '../../config/constants/view-events';
import {getId} from '../../core-utilities/domain/ReduxUtils';
import {personnelStates} from '../router';
import teamsEditDialogTemplate from './teams-edit-dialog.html';


module.exports = [
  '$scope',
  '$ngRedux',
  '$modal',
  '$ionicViewSwitcher',
  '$exceptionHandler',
  '$contextMenu',
  '$permissions',
  '$popup',
  'TeamDomain',
  'team',
  TeamsDetailController];

const VIEW_ACTIONS = {
  canEdit: 'organization_teams_edit',
};

function TeamsDetailController(
  $scope,
  $ngRedux,
  $modal,
  $ionicViewSwitcher,
  $exceptionHandler,
  $contextMenu,
  $permissions,
  $popup,
  TeamDomain,
  team,
) {
  const vm = $scope.teamsDetail = this;
  vm.team = team;

  vm.openEditor = openDialog;
  vm.openContext = showMenu;

  $permissions.bindOrg($scope, vm, VIEW_ACTIONS);

  let cleanup = init();
  $scope.$on(IONIC_VIEW_ENTER, () => cleanup = init());
  $scope.$on(IONIC_VIEW_LEAVE, performCleanup);
  $scope.$on(SCOPE_DESTROY, performCleanup);

  function performCleanup() {
    if (cleanup) {
      cleanup();
      cleanup = null;
    }
  }

  /*****************************************************************************************************************
   * Header Buttons
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Context Menu Actions
   ****************************************************************************************************************/

  const DELETE_TEAM = {
    permission: 'organization_teams_edit',
    action: {messageId: 'teams.details.context.delete.label', action: deleteTeam, important: true},
  };

  function showMenu() {
    const orgId = getId(getOrganization($ngRedux.getState()));
    if (!orgId) return;

    const typeName = vm.team.type && vm.team.type.name;
    const checkActions = [];
    $contextMenu.addActionByOrg(checkActions, orgId, DELETE_TEAM);

    $contextMenu.showByPermission({
      titleMessageId: 'teams.details.context.title.label',
      titleMessageParams: {teamType: typeName || ''},
      cancelMessageId: 'defaults.context.cancel.label',
      actions: checkActions,
    });
  }

  function deleteTeam() {
    const typeName = vm.team.type && vm.team.type.name;
    // TODO(i18n): translate task delete confirmation
    return $popup.confirm({
      title: 'Delete ' + typeName || '',
      template: 'Are you sure you want to delete ' + vm.team.toString(),
    }).then(function (result) {
      if (result) {
        return vm.team.$delete().then(function onDeleteTeamSuccess() {
          $ionicViewSwitcher.nextDirection('back');
          $ngRedux.dispatch(stateGo(personnelStates.personnelHome));
        }, function onDeleteError(error) {
          $exceptionHandler(error, 'TeamDetailController.deleteTeam error occurred deleting user');
        });
      }
    });
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  $scope.openDialog = openDialog;

  function openDialog() {
    // console.log('open dialog');
    $modal.show({
      template: teamsEditDialogTemplate,
      controller: 'TeamsEditDialogController',
      locals: {
        team: team,
        teamType: null,
      },
    })/* .then(function (result) {
     console.log(result);
     })*/;
  }


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/

  function init() {

    if (vm.team) {
      // console.log('TeamsDetailController.init ', vm.team, team);
      vm.personnel = TeamDomain.$getMembersList(getId(vm.team));
    }

    // Setup watcher for whether the current user is a member of this team for the team chat indicator,

    let memberRef;
    let listener = null;
    let memberTimeout = null;
    $ngRedux.state$
      .map(getOrgProfile)
      .filter((it) => !!it)
      .take(1)
      .subscribe(function (profile) {
        $scope.$evalAsync(() => {
          memberRef = TeamDomain.isMemberRef(getId(team), getId(profile));
          createMemberWatcher();
        });
      });

    function createMemberWatcher() {
      listener = memberRef.on('value', function (ss) {
        $scope.$safeApply(function () {
          vm.isMember = !!ss.val();
        });
      }, function (err) {
        memberTimeout = setTimeout(createMemberWatcher, 20000);
      });
    }

    return function cleanup() {
      if (memberRef && listener) {
        memberRef.off('value', listener);
        memberRef = null;
        listener = null;
      }

      if (memberTimeout !== null) {
        clearTimeout(memberTimeout);
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/TeamsDetailController.js